import '../stylesheets/advanced_search';
import genAccord from "./_component/accordion";
import { width } from "./_function/detectDevice";

$(function () {
  // アコーディオン
  genAccord('.other-conditions', '.tableWrap', '> a');

  // リセット
  $('button.clear').on('click', function (e) {
    e.preventDefault();
    $(this.form).find('input[type="text"], textarea, select').val('').end().find(':checked').prop('checked', false);
  });

  // 権利確定月
  if ($('#record-month-all + label').length) {
    $('#record-month-all').on('change', function () {
      $('.record-month').prop('checked', $(this).prop('checked'));
    });
    $('.record-month').on('change', function () {
      let isAllMonthChecked = ($('.record-month:checked').length == $('.record-month').length);
      $('#record-month-all + label').prop('checked', isAllMonthChecked);
    });
  }

  // カテゴリ
  $('input[type="checkbox"].category').on('change', function () {
    // 自身に紐づく全ての小カテゴリの選択状態を、自身の選択状態に合わせる
    const checked = $(this).prop('checked');
    $(this).closest('.checkboxes').find('input[type="checkbox"].subcategory').each(function () {
      $(this).prop('checked', checked);
    });
  });
  $('input[type="checkbox"].subcategory').on('change', function () {
    // 自身に紐づく大カテゴリについて、紐づく小カテゴリが全て選択されている場合は選択し、選択されていないものがある場合は選択を解除する
    const node = $(this).closest('.category-and-subcategories');
    const isAllCheckboxesChecked = $(node).find('input[type="checkbox"].subcategory:checked').length == $(node).find('input[type="checkbox"].subcategory').length;
    $(node).find('input[type="checkbox"].category').prop('checked', isAllCheckboxesChecked);
  });

  // 市場
  if ($('#market-all').length) {
    $('#market-all').on('change', function () {
      $('.market').prop('checked', $(this).prop('checked'));
    });

    $('.market').on('change', function () {
      let isAllMarketChecked = ($('.market:checked').length == $('.market').length);
      $('#market-all').prop('checked', isAllMarketChecked);
    });
  }

  // カテゴリアコーディオン
  (function() {
    const clsOpen = 'accOpen';
    const $acc = $('.withCat tr.cat');
    const $btn = $acc.find('th');
    const $cont = $acc.find('.checkboxes');
    $btn.on('click', function(e) {
      if (width() !== 'pc') {
        e.preventDefault();
        const parent = $(this).closest('tr');
        const target = parent.find('.checkboxes');
        const h = target.outerHeight();
        if (!parent.hasClass(clsOpen)) {
          parent.addClass(clsOpen);
          target.parent().css('height', h);
        } else {
          parent.removeClass(clsOpen);
          target.parent().css('height', 0);
        }
      }
    });
    $(window).on('load resize', function() {
      if (width() === 'pc') {
        $cont.each(function(i, e) {
          const parent = $(e).closest('tr');
          parent.removeClass(clsOpen);
          parent.find('td').css('height', '');
        });
      }
    });
    $(window).on('resize', function() {
      $btn.each(function(i, e) {
        const parent = $(e).closest('tr');
        const target = parent.find('.checkboxes');
        const h = target.outerHeight();
        if (parent.hasClass(clsOpen)) {
          parent.addClass(clsOpen);
          target.parent().css('height', h);
        } else {
          parent.removeClass(clsOpen);
          target.parent().css('height', 0);
        }
      });
    });
  })()
});
